const getters = {
  menus: state => state.app.menus,
  addRouters: state => state.app.addRouters,
  userInfo: state => state.user.info,
  roomInfo: state => state.room.info,
  companyCode: state => state.user.companyCode,
  restaruantInfo: state => state.user.restaruantInfo,
  appConfig: state => state.app.appConfig,
  roomStatusShowType: state => state.room.roomStatusShowType,
};

export default getters;
